// removed by extract-text-webpack-plugin
module.exports = {"Videos__hero":"src-pages----videos-module---Videos__hero---1mv_6","Videos__heading":"src-pages----videos-module---Videos__heading---3LNI-","Videos__summary":"src-pages----videos-module---Videos__summary---3IbOp","Videos__container":"src-pages----videos-module---Videos__container---2f8bE","spinAround":"src-pages----videos-module---spinAround---uzKIz"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/videos.module.scss
// module id = 460
// module chunks = 169559349407212